import { render, staticRenderFns } from "./StatmentCodeMappingRuleDialog.vue?vue&type=template&id=0f4b3104&scoped=true"
import script from "./StatmentCodeMappingRuleDialog.vue?vue&type=script&lang=ts"
export * from "./StatmentCodeMappingRuleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b3104",
  null
  
)

export default component.exports